@if(isDataLoading){
<div class="example-loading-shade">
    @if(isDataLoading){
    <mat-spinner></mat-spinner>
    }
</div>
}
@if(showFilter){
<div class="col-lg-12 nopadding">
    <app-filter-panel 
        [GridColumns]="gridColumns" 
        [DefaultFilterArray]="DefaultFilterArray"
        [ResetLabel]="isFilterLabelReset" 
        (FilterEvent)="FilterApplyFilterEvent($event)"
        [isAddFilter]=false>
    </app-filter-panel>
</div>}
@if(staticFilter){
<div>
    <!-- <div> -->
    <mat-accordion #accordion="matAccordion" [multi]="true">
        <!--Filter Code  -->
        <mat-expansion-panel [expanded]="true">
            <mat-panel-description>
                <div class="col-lg-12 nopadding">
                    <mat-chip-listbox aria-label="filter" class="col-lg-12 nopadding">
                        <span>
                            <label for="audit-trail-filter">
                                <i class="fa fa-filter" id="audit-trail-filter"></i>
                            </label>
                            <mat-chip selected color="green" matTooltip="Date" [matTooltipShowDelay]="1000" matTooltipPosition="after"
                                id="audit-trail-date">
                                Report Date: {{reportDate}}
                            </mat-chip>
                            <mat-chip selected color="green" matTooltip="Symbol" [matTooltipShowDelay]="1000" matTooltipPosition="after"
                                id="audit-trail-symbol">
                                Symbol: {{symbol}}
                            </mat-chip>
                            <mat-chip selected color="green" matTooltip="FirmROEID" [matTooltipShowDelay]="1000" matTooltipPosition="after"
                                id="audit-trail-firmROEID">
                                FirmROEID: {{firmROEID}}
                            </mat-chip>
                            <mat-chip selected color="green" matTooltip="Event Type" [matTooltipShowDelay]="1000" matTooltipPosition="after"
                                id="audit-trail-eventType">
                                Event Type: {{type}}
                            </mat-chip>
                        </span>
                    </mat-chip-listbox>
                </div>
            </mat-panel-description>
        </mat-expansion-panel>
    </mat-accordion>
</div>}
<div class="col-md-12 nopadding">
    <p-table #dt 
        [value]="auditData" 
        [columns]="cols" 
        [resizableColumns]="true" 
        [lazy]="false"    
        columnResizeMode="expand"
        [sortOrder]="constantService.DEFAULT_SORDORDER_ASC" 
        [(selection)]="selectedRows" [paginator]="true"
        selectionMode="single" appendTo="body" 
        alwaysShowPaginator="true" 
        paginatorPosition="both"
        showCurrentPageReport="true" 
        [rows]="constantService.DEFAULT_ROWSIZE" 
        [totalRecords]="auditData.length > 0 ? auditData.length : 1"
        [pageLinks]="constantService.DEFAULT_PAGELINKS" 
        sortMode="multiple"
        [rowsPerPageOptions]="constantService.DEFAULT_ROWSPERPAGEOPTION"
        [scrollable]="true" 
        scrollHeight="70vh"
        styleClass ="tableData auditTable">
        <ng-template pTemplate="emptymessage" let-columns>
            <tr>
                <td [attr.colspan]="columns.length">
                    {{constantService.NO_RECORDFOUND_MSG}}
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
                @for (col of columns; track col;){
                <th id="colHeader" pResizableColumn [pSortableColumn]="col.field">
                    {{col.header}}
                    @if((col.header | lowercase) !== 'action'){
                    <p-sortIcon [field]="col.field"></p-sortIcon>}
                </th>}
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
            <tr [pSelectableRow]="row" [pSelectableRowIndex]="ri">
                @for (col of columns; track col;){
                <td class="ui-resizable-column"
                    [ngClass]="col.header==='Action' ? 'center':''">
                    <!-- set String -->
                     @if((col.datatype | lowercase) =='string' || (col.datatype | lowercase) =='char'){
                    <span>
                        {{row[col.field]}}
                    </span>
                    }

                    <!-- set JSON -->
                     @if((col.datatype | lowercase) =='json'){
                    <span>
                        {{row[col.field]}}
                    </span>}

                    <!-- set int  -->
                     @if((col.datatype | lowercase) =='int' || (col.datatype | lowercase) =='float'){
                    <span style="float:right;">
                        {{row[col.field] * 1}}
                    </span>}

                     @if(col.header==='Action'){
                    <span>
                        <p-button matTooltip="View Diff" [matTooltipShowDelay]="1000" matTooltipPosition="above" appendTo="body"
                            icon="fa fa-fw fa-code" [id]="'diff'+ rowIndex" (click)="onJsonViewer(row)"
                            class="btnAction">
                        </p-button>
                    </span>}

                </td>}
            </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft">
            Total Records: {{ auditData?.length == 0 ? 0 : auditData?.length }}
        </ng-template>
        <ng-template pTemplate="paginatorright">
            <button type="button" [matTooltip]="this.userService.enableFileExport()?
                    'Export':'Export service is disabled'"
                     [matTooltipShowDelay]="1000" id="export-audit-trail" label="export-audit-trail"
                class="exportBtn" (click)="exportToCSV()"> Export <i class="fa fa-download" aria-hidden="true"></i>
            </button>
        </ng-template>
    </p-table>
    <div>
        @if(isJsonViewer){
        <app-json-viewer-dialog id="audit-trail-json-viewer" (closeEventDialog)="isJsonViewer = false"
            [selectedJSONObject]="selectedJSONObject" [originalJSONObject]="originalJSONObject"
            [isJSONViewerOpen]="isJsonViewer">
        </app-json-viewer-dialog>}
    </div>

</div>